export default "__VITE_ASSET__DuFifd46__"